import 'components/layouts/notification/index.scss';
import {
  Dispatch,
  memo,
  SetStateAction,
  useCallback, useMemo, useRef, useState,
} from 'react';
import { DataNotification } from '.';
import useScrollTrigger from './useScrollTrigger';

function Content({
  allDataLoaded,
  currentTab,
  currentPage,
  data,
  handleRead,
  fetchData,
  setData,
  setDataUnread,
  setCurrentPage,
}: Readonly<{
  allDataLoaded: {
    unread: {
      allLoaded: boolean;
    };
    read: {
      allLoaded: boolean;
    };
  },
  data: DataNotification;
  currentTab: number;
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<{
    read: number;
    unread: number;
  }>>;
  setData: Dispatch<SetStateAction<DataNotification>>;
  setDataUnread: Dispatch<SetStateAction<DataNotification>>
  handleRead: (notification_id: string) => Promise<void>;
  fetchData: ({
    page, pageSize, is_read, ln,
  }: {
    page: string;
    pageSize: string;
    is_read?: boolean;
    ln?: string;
  }) => Promise<void>
}>) {
  console.log('<<dt-content-2', data);

  const formatDateTime = useCallback((isoString: string) => {
    const date = new Date(isoString);

    return {
      date: `${String(date.getUTCDate()).padStart(2, '0')}-${String(
        date.getUTCMonth() + 1,
      ).padStart(2, '0')}-${date.getUTCFullYear()}`,
      time: `${String(date.getUTCHours()).padStart(2, '0')}.${String(
        date.getUTCMinutes(),
      ).padStart(2, '0')}`,
    };
  }, []);
  const [loading, setLoading] = useState(false);
  const scrollableDivRef = useRef(null);
  const ln = localStorage.getItem('language') ?? 'id';
  const handleScrollEnd = useCallback(async () => {
    const is_read = Number(currentTab) === 1;
    if (allDataLoaded[is_read ? 'read' : 'unread'].allLoaded) return;
    try {
      await fetchData({
        page: String(currentPage[is_read ? 'read' : 'unread'] + 1), pageSize: '15', is_read, ln,
      });
      setLoading(false);
      setCurrentPage((prev) => ({
        ...prev,
        [is_read ? 'read' : 'unread']: prev[is_read ? 'read' : 'unread'] + 1,
      }));
    } catch (error) {
      setLoading(false);
    }
  }, [setLoading, currentTab, currentPage, fetchData, ln]);

  useScrollTrigger(scrollableDivRef, handleScrollEnd, loading, setLoading);
  console.log(data, '<<data-last');

  if (data?.length > 0) {
    const newDatas = [...data];
    return (
      <div className="notification-list" ref={scrollableDivRef}>
        {newDatas.map((value) => (
          <div
            key={`${value.notification_id}-${value.is_read}`}
            aria-hidden
            onClick={() => !value.is_read && handleRead(value.notification_id)}
            className={`${
              !value.is_read && 'cursor-pointer'
            } w-100 d-flex justify-content-center align-items-center`}
          >
            <div className="content-wrap">
              <div className="content-wrap-item">
                <div
                  className="d-flex flex-row justify-content-center align-items-center"
                  style={{
                    gap: '19px',
                  }}
                >
                  <div className="notification_icon" />
                  <div className="detail-item">
                    {value.feature}
                  </div>
                </div>
                <div className="message-item">
                  {value.message}
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                  Veritatis iusto voluptate qui necessitatibus aliquam animi
                  error corrupti quis non at consequuntur impedit, nemo,
                  numquam dolore corporis? At similique illum eaque?
                </div>
                <div className="d-flex flex-row align-items-center">
                  {!value.is_read && <div className="unread mr-2" />}
                  <div className="date d-flex flex-column">
                    <div>{formatDateTime(value.created_at).date ?? '-'}</div>
                    <div>
                      <b>{formatDateTime(value.created_at).time ?? '-'}</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
        <div className="d-flex text-center justify-content-center align-items-center pt-4">
          {allDataLoaded[currentTab === 1 ? 'read' : 'unread'].allLoaded ? 'all data is loaded' : loading && <p>Loading...</p>}
        </div>
      </div>
    );
  }
  return (
    <div className="w-100 d-flex justify-content-center align-items-center">
      No Notification
    </div>
  );
}

export default memo(Content);
